<script>
export default {
		mixins: [
		],
		/**
		 * @instance
		 **/
		computed: {
			valid_target: function(){
				return this.$refs.valid_target;
			},
		},
		methods: {
			/**
			 * バリデーション <br>
			 * @instance
			 */
			validate: function( ){
				return this.validateSub();
			},
			/**
			 * バリデーション <br>
			 * ******* 内部処理 *******<br>
			 *
			 * @function  event_close
			 * @returns {bool} is - クローズフラグ
			 * @instance
			 */
			validateSub: function( ){
//console.log("validate");
				var is = true;
				// computedを使用すると読み込みの順番の問題でundefinedになる場合がある
				if(this.$refs.valid_target){
					if(Array.isArray(this.$refs.valid_target)){
						for(var key in this.$refs.valid_target){
							var target = this.$refs.valid_target[key];
							target.validate((valid) => {
								if (valid) {
//console.log('submit!');
								} else {
//console.log('error submit!!');
									is = false;
									return false;
									}
							});	
						}
					}else{
						var target = this.$refs.valid_target;
						target.validate((valid) => {
							if (valid) {
//console.log('submit!');
							} else {
//console.log('error submit!!');
								is = false;
								return false;
							}
						});
					}
				} else {
					console.log("error valid_target undefined");
				}
				return is;
			},
			clearMessage: function(){
				if(this.$refs.valid_target){
					if(Array.isArray(this.$refs.valid_target)){
						for(var key in this.$refs.valid_target){
							this.$refs.valid_target[key].clearValidate();
						}
					}
					else{
						this.$refs.valid_target.clearValidate();
					}
				}
			},
		},
	}
</script>



// WEBPACK FOOTER //
// resources/assets/js/common/validate/edit.mixin.vue